export default "__VITE_ASSET__duc6jzk4__"